export const EQUALS = "equalTo";
export const NOT_EQUALS = "notEqualTo";
export const GREATER_THAN = "greaterThan";
export const GREATER_THAN_EQUALS = "greaterThanOrEqualTo";
export const LESS_THAN = "lessThan";
export const LESS_THAN_EQUALS = "lessThanOrEqualTo";
export const BETWEEN = "between";
export const NOT_BETWEEN = "notBetween";
export const CONTAINS = "contains";
export const DOES_NOT_CONTAIN = "doesNotContain";
